/**
 * rfqRouteParser.ts
 *
 * Centralised helper for extracting the RFQ requestId from the current
 * pathname.  Every RFQ sub-page previously had its own regex/split logic
 * — this module replaces all of them with a single source of truth.
 *
 * Supported route patterns:
 *   /dashboard/rfqs/open/:requestId           (admin)
 *   /dashboard/rfqs/open/:requestId/products   (admin sub-page)
 *   /dashboard/rfqs/open/:requestId/suppliers   …etc
 *   /dashboard/admin/request/:requestId         (admin legacy)
 *   /dashboard/user/rfq/:requestId              (basic-plan user)
 *   /dashboard/user/rfq/:requestId/products     (user sub-page)
 */

/** Matches all known RFQ route patterns and captures the requestId. */
const RFQ_ROUTE_RE =
  /\/dashboard\/(?:rfqs\/open|admin\/request|user\/rfq)\/([^/?#]+)/;

/**
 * Extract the RFQ requestId from a pathname.
 *
 * @returns The requestId string, or `null` if the path doesn't match
 *          any known RFQ route pattern.
 */
export function getRFQRequestIdFromPath(pathname: string): string | null {
  const match = pathname.match(RFQ_ROUTE_RE);
  return match ? match[1] : null;
}

/**
 * Returns `true` when `pathname` is inside an RFQ sub-route (any depth).
 */
export function isRFQSubRoute(pathname: string): boolean {
  return RFQ_ROUTE_RE.test(pathname);
}
